import { useTenantConfig } from './useTenantConfig'

export const useGoogleAds = () => {
    const { config } = useTenantConfig()
    let isInitialized = false

    const initializeGoogleAds = () => {
        const conversionId = config.value?.googleAdsConversionId
        if (isInitialized || !conversionId) return

        try {
            const script = document.createElement('script')
            script.async = true
            script.src = `https://www.googletagmanager.com/gtag/js?id=${conversionId}`
            document.head.appendChild(script)

            window.dataLayer = window.dataLayer || []
            const gtag = function () { window.dataLayer.push(arguments) }
            window.gtag = gtag
            gtag('js', new Date())
            gtag('config', conversionId)

            isInitialized = true
            console.log('✅ Google Ads initialized:', conversionId)
        } catch (error) {
            console.error('❌ Failed to initialize Google Ads:', error)
        }
    }

    const trackConversion = (conversionUrl = null) => {
        const conversionId = config.value?.googleAdsConversionId
        const conversionLabel = config.value?.googleAdsConversionLabel
        if (!conversionId || !conversionLabel || !window.gtag) return

        window.gtag('event', 'conversion', {
            send_to: `${conversionId}/${conversionLabel}`,
            event_callback: () => { if (conversionUrl) window.location = conversionUrl }
        })
    }

    return { initializeGoogleAds, trackConversion }
}
